<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="tableHeaders"
                        :loading="isFetchResults"
                        loading-text="Загрузка данных. Ожидайте"
                        :items="tableData"
                        disable-pagination
                        class="elevation-1"
                        hide-default-footer
                    >
                        <template v-slot:[`item.organization`]="{ item }">
                            <a @click.prevent="onClickOrgBtn(item)">{{ item.organization }}</a>
                        </template>
                        <template v-slot:[`item.sent_result`]="{ item }">
                            {{ JSON.stringify(item.sent_result) }}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="text-center">
                        <v-pagination
                            :disabled="isFetchResults"
                            v-model="pageParams.current_page"
                            :length="pageParams.last_page"
                            total-visible="25"
                            @input="onPaginate"
                        ></v-pagination>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    </template>
    
    <script>
    import * as api from '@/api/admin/importDebts';
    import {mapActions} from 'vuex';

    export default {
        name: 'AdminImportDebtResponseErrors',
        components:{
        },
        data(){
            return {
                tableData: [],
                pageParams: {},
                isFetchResults: false,
                tableHeaders: [
                    { text: 'Id запроса', value: 'subrequestGUID' },
                    { text: 'Дата ответа', value: 'created_at' },
                    { text: 'Организация', value: 'organization' },
                    { text: 'Пространство', value: 'work_space_id' },
                    { text: 'Статус ответа', value: 'sent_status_slug' },
                    { text: 'Результат', value: 'sent_result' },
                ]
            }
        },
        created(){
            this.load();
        },
    
        watch:{
        },
        methods: {
            ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
            ...mapActions('workspace', ['CHECKOUT_WORKSPACE_ADMIN', 'CHECKOUT_ORGANIZATION']),
            onClickOrgBtn(item){
                this.CHECKOUT_WORKSPACE_ADMIN(item.work_space_id).then(async () => {
                    return await this.CHECKOUT_ORGANIZATION(item.organization_id);
                });
                // .then(() => {
                //     this.$router.push({name: 'Social'});
                // });
            },
            async load(){
                this.isFetchResults = true;
                try{
                    let {data} = await api.errors(this.apiParams);
                    this.pageParams = {...data.meta};
                    this.setTableDate(data.data);
                }catch(e){
                    console.log(e);
                    this.SHOW_ERROR('Ошибка загрузки данных. См консоль');
                }finally{
                    this.isFetchResults = false;
                }
            },
            setTableDate(newData){
                this.tableData.splice(0, this.tableData.length, ...newData);
            },
            onPaginate(){
                this.load();
            }
        },
    
        computed: {
            apiParams(){
                return {
                    page: this.pageParams.current_page
                }
            }
        }
    }
    </script>